// extracted by mini-css-extract-plugin
export default {"container":"ScoreMarker_container__gVCwG","score":"ScoreMarker_score__LDzlI","scoreHigh":"ScoreMarker_scoreHigh__Ax+yt"};